module.exports = __webpack_public_path__ + "static/media/mastercard.b92f7fad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/credit_cards/mastercard.svg
// module id = 171
// module chunks = 0